import { TargetPlatform } from "../../../shared/types/TargetPlatform";

export type TargetPlatformOption = {
    value: TargetPlatform;
    name: keyof typeof TargetPlatform;
    label: string;
};

export const targetPlatformOptions: TargetPlatformOption[] = [
    { value: TargetPlatform.None, name: "None", label: "None" },
    { value: TargetPlatform.Binance, name: "Binance", label: "Binance" },
    { value: TargetPlatform.Deribit, name: "Deribit", label: "Deribit" },
    { value: TargetPlatform.SamsungWallet, name: "SamsungWallet", label: "Samsung Wallet" },
    { value: TargetPlatform.TrustWallet, name: "TrustWallet", label: "Trust Wallet" },
    { value: TargetPlatform.RevolutX, name: "RevolutX", label: "RevolutX" },
];
